export default __webpack_public_path__ + "static/media/barrelProcess2.f057b6b0.png";